import { UserManager } from 'oidc-client';
import SessionService from './SessionService';

const SESSION_SYNC_KEY = 'pgdb_session_sync';

const settings = {
   authority: process.env.REACT_APP_IDENTITY_AUTHORITY,
   client_id: 'implicit',
   redirect_uri: process.env.REACT_APP_REDIRECT_URL,
   silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URL,
   post_logout_redirect_uri: process.env.REACT_APP_POSTLOGOUT_REDIRECT_URL,
   automaticSilentRenew: true,
   response_type: 'code',
   scope: 'openid profile email pgdbAPI.full_access IdentityServerApi',
   filterProtocolClaims: true,
   loadUserInfo: true,
   monitorSession: false
};

export const userManager = new UserManager(settings);

userManager.events.addUserLoaded(async () => {
   const response = await userManager.getUser();
   await SessionService.saveSession(response);
   await SessionService.saveUser(response.profile);
});

userManager.events.addUserSignedOut(() => {
   SessionService.deleteSession()
      .then(() => {
         SessionService.deleteUser().then(() => {
            // Newer versions of Edge retain session data
            // expiring the session cookie to resolve this
            sessionStorage.clear();
            localStorage.clear();
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
               const cookie = cookies[i];
               const eqPos = cookie.indexOf('=');
               const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
               document.cookie = `${name}  =;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
            }
            window.location.href = window.location.origin;
         });
      })
      .catch(err => {
         console.error(`Could not log the user out. ${err}`);
         throw err;
      });
});

// Reload when another tab completes a login or logout so all tabs stay in sync.
// The storage event only fires in tabs that did NOT make the change.
window.addEventListener('storage', event => {
   if (event.key === SESSION_SYNC_KEY || event.key === null) {
      window.location.reload();
   }
});

export const hasSessionExpired = async () => {
   const user = await userManager.getUser();
   if (user) {
      return user.expired;
   }
   return null;
};

export const login = async () => {
   return userManager.signinRedirect();
};

export const signinRedirectCallback = async () => {
   const result = await userManager.signinRedirectCallback();
   // Notify other tabs to reload so they pick up the new session
   try {
      localStorage.setItem(SESSION_SYNC_KEY, String(result.expires_at));
   } catch (e) {}
   return result;
};

export const initSessionService = async store => {
   const response = await userManager.getUser();
   SessionService.initSessionService(
      store,
      { driver: 'COOKIES' },
      response ? response.id_token : null
   );
};

export const getUser = () => {
   return userManager.getUser();
};

export const renewToken = () => {
   return userManager.signinSilent();
};

/* eslint-disable camelcase */
export const logout = id_token => {
   userManager.removeUser();
   return userManager.signoutRedirect({ id_token_hint: id_token });
};

export const logoutCallback = () => {
   return userManager.signoutRedirectCallback();
};

export const deleteUser = () => {
   return SessionService.deleteUser();
};

export const deleteSession = () => {
   return SessionService.deleteSession();
};

export const getToken = () => {
   return SessionService.loadSession();
};
